import React from "react";
import { typeContactService } from "../jwt/_services/hotel/typeContactService";

export const typeContactProvider = {
    getOptions,
    getItem,
};

async function getOptions() {
    try {
        const listItems = await typeContactService.getList();
        return listItems.map((itemData) => {
            const {id, code } = itemData
            return (
                {
                    id: id,
                    value: code,
                    label: <div><label>{code}</label></div>
                }
            )
        });
    } catch (error) {
        this.setState({error: error.message});
    }
}

async function getItem(id) {
    try {
        const item = await typeContactService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        this.setState({error: error.message});
    }
}